<app-shell-admin-warning-banner></app-shell-admin-warning-banner>

<section class="changelog-admin">
	<header class="toolbar card">
		<div class="toolbar__filters">
			<label class="field">
				<span>Release family</span>
				<input type="text" class="form-control" [(ngModel)]="filterReleaseFamilyKey" placeholder="ApplicationLink3" />
			</label>

			<label class="field field--small">
				<span>Take</span>
				<input type="number" class="form-control" [(ngModel)]="take" min="1" max="200" />
			</label>

			<label class="field field--checkbox">
				<input type="checkbox" [(ngModel)]="includePreRelease" />
				<span>Include pre-release</span>
			</label>
		</div>

		<div class="toolbar__actions">
			<dx-button text="Load grouped releases" type="default" [disabled]="loadingOverview" (onClick)="loadOverview()"></dx-button>
			<dx-button text="Refresh selected" type="normal" [disabled]="selectedOverview == null || loadingEntry" (onClick)="refreshSelectedRelease()"></dx-button>
		</div>
	</header>

	<div class="workspace">
		<section class="workspace__column card">
			<div class="card-body">
				<div class="section-header">
					<h5 class="section-title">Releases</h5>
					<span class="section-meta">{{ overviewRows.length }} loaded</span>
				</div>

				<dx-data-grid
					class="overview-grid"
					[dataSource]="overviewRows"
					keyExpr="selectionKey"
					[showBorders]="true"
					[hoverStateEnabled]="true"
					[selectedRowKeys]="selectedRowKeys"
					(onSelectionChanged)="onOverviewSelectionChanged($event)"
				>
					<dxo-selection mode="single"></dxo-selection>
					<dxo-sorting mode="multiple"></dxo-sorting>
					<dxo-filter-row [visible]="true"></dxo-filter-row>
					<dxo-search-panel [visible]="true"></dxo-search-panel>
					<dxo-paging [pageSize]="12"></dxo-paging>
					<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[12, 25, 50]"></dxo-pager>

					<dxi-column dataField="releaseFamilyName" caption="Release family"></dxi-column>
					<dxi-column dataField="version" caption="Version" [width]="120"></dxi-column>
					<dxi-column dataField="status" caption="Status" [width]="130"></dxi-column>
					<dxi-column dataField="itemCount" caption="Items" [width]="80"></dxi-column>
					<dxi-column dataField="visibleForUsersItemCount" caption="User items" [width]="95"></dxi-column>
					<dxi-column dataField="sourceCount" caption="Sources" [width]="85"></dxi-column>
					<dxi-column dataField="isPreRelease" caption="Pre-release" dataType="boolean" [width]="100"></dxi-column>
					<dxi-column dataField="sourceApplicationsText" caption="Source apps"></dxi-column>
					<dxi-column dataField="highlightsText" caption="Highlights"></dxi-column>
					<dxi-column dataField="latestSourceCreatedAtUtc" caption="Latest source" dataType="datetime" format="yyyy-MM-dd HH:mm" [width]="160"></dxi-column>
					<dxi-column dataField="publishedAtUtc" caption="Published" dataType="datetime" format="yyyy-MM-dd HH:mm" [width]="160"></dxi-column>
				</dx-data-grid>
			</div>
		</section>

		<section class="workspace__column workspace__column--editor card" *ngIf="hasSelection; else emptyState">
			<div class="card-body" *ngIf="selectedOverview != null && release != null && editorPayload != null">
				<div class="section-header section-header--stack">
					<div>
						<h5 class="section-title">{{ selectedOverview.releaseFamilyName }} {{ selectedOverview.version }}</h5>
						<div class="section-meta section-meta--chips">
							<span class="badge badge-primary">{{ release.status }}</span>
							<span class="badge badge-light">{{ selectedOverview.releaseFamilyKey }}</span>
							<span class="badge badge-light" *ngIf="selectedOverview.isPreRelease">Pre-release</span>
							<span class="badge badge-warning" *ngIf="isDirty">Unsaved draft</span>
						</div>
					</div>

					<div class="action-row">
						<dx-button text="Save Draft" type="default" [disabled]="saving" (onClick)="saveDraft()"></dx-button>
						<dx-button text="Ready For Review" type="normal" [disabled]="saving" (onClick)="markReadyForReview()"></dx-button>
						<dx-button text="Publish" type="success" [disabled]="saving" (onClick)="publish()"></dx-button>
						<dx-button text="Archive" type="danger" [disabled]="saving" (onClick)="archive()"></dx-button>
						<dx-button text="Use Suggested" type="default" [disabled]="saving" (onClick)="resetDraftToSuggested()"></dx-button>
						<dx-button
							text="Restore Published"
							type="default"
							[disabled]="saving || release.publishedPayload == null"
							(onClick)="restorePublishedToDraft()"
						></dx-button>
					</div>
				</div>

				<div class="callout callout--danger" *ngIf="release.draftPayloadParseError">
					Draft parse error: {{ release.draftPayloadParseError }}
				</div>

				<div class="callout callout--danger" *ngIf="release.publishedPayloadParseError">
					Published parse error: {{ release.publishedPayloadParseError }}
				</div>

				<div class="callout callout--warning" *ngFor="let warning of release.validationWarnings">
					<strong>{{ warning.code }}</strong>: {{ warning.message }}
				</div>

				<div class="metadata-grid">
					<div class="field">
						<span>Release family key</span>
						<input type="text" class="form-control" [ngModel]="editorPayload.releaseFamilyKey" readonly />
					</div>

					<div class="field">
						<span>Release family name</span>
						<input type="text" class="form-control" [(ngModel)]="editorPayload.releaseFamilyName" (ngModelChange)="markDirty()" />
					</div>

					<div class="field">
						<span>Version</span>
						<input type="text" class="form-control" [(ngModel)]="editorPayload.version" (ngModelChange)="markDirty()" />
					</div>

					<div class="field">
						<span>Release date</span>
						<input type="text" class="form-control" [(ngModel)]="editorPayload.releaseDate" (ngModelChange)="markDirty()" placeholder="2026-04-02" />
					</div>

					<div class="field field--wide">
						<span>Title</span>
						<input type="text" class="form-control" [(ngModel)]="editorPayload.title" (ngModelChange)="markDirty()" />
					</div>

					<div class="field field--wide">
						<span>Summary</span>
						<textarea class="form-control textarea" rows="3" [(ngModel)]="editorPayload.summary" (ngModelChange)="markDirty()"></textarea>
					</div>

					<div class="field field--wide">
						<span>Source applications</span>
						<div class="chip-list">
							<span class="chip" *ngFor="let applicationKey of editorPayload.sourceApplicationKeys">{{ applicationKey }}</span>
						</div>
					</div>
				</div>

				<section class="linked-sources">
					<div class="section-header section-header--stack">
						<div>
							<h5 class="section-title">Linked source exports</h5>
							<p class="muted">Select the raw changelog exports that should belong to this grouped release, even if their individual app versions differ.</p>
						</div>

						<div class="action-row action-row--tight">
							<button type="button" class="source-picker__action" (click)="selectAllAvailableSources()">Select all family sources</button>
							<button type="button" class="source-picker__action" (click)="selectSourcesMatchingVersion(selectedOverview.version)">Use current row version</button>
							<button type="button" class="source-picker__action" (click)="resetSourceSelectionToSaved()">Use saved selection</button>
						</div>
					</div>

					<div class="callout callout--info">
						Selected {{ selectedSourceIds.length }} of {{ release.availableSources.length }} available raw exports for this grouped release. Save first, then use Suggested if you want the draft regenerated from this selection.
					</div>

					<div class="source-picker-list">
						<div class="source-picker" *ngFor="let source of release.availableSources; trackBy: trackBySourceId">
							<div class="source-picker__select">
								<input type="checkbox" [checked]="isSelectedSource(source.id)" (change)="toggleSourceSelection(source.id, $any($event.target).checked)" />
							</div>
							<div class="source-picker__body">
								<div class="source-picker__header">
									<strong>{{ source.applicationName || source.applicationKey }}</strong>
									<span class="badge badge-light">{{ source.version }}</span>
								</div>
								<div class="source-picker__meta">
									<span>{{ source.itemCount }} items</span>
									<span *ngIf="source.releaseDate">{{ source.releaseDate }}</span>
									<span *ngIf="source.buildVersion">{{ source.buildVersion }}</span>
									<span *ngIf="source.sourceBranch">{{ source.sourceBranch }}</span>
								</div>
								<div class="source-picker__sections">{{ formatSectionOverview(source.sections) }}</div>
							</div>
							<button type="button" class="source-picker__inspect" (click)="inspectSource(source.id)">Inspect</button>
						</div>
					</div>
				</section>

				<div class="bulk-toolbar">
					<div>
						<h6>Bulk update</h6>
						<p class="muted">Select draft items below, then update section, visibility, scope, or target applications.</p>
					</div>

					<div class="bulk-toolbar__controls">
						<select class="form-control" [(ngModel)]="bulkSectionName">
							<option value="">Keep section</option>
							<option *ngFor="let sectionName of allowedSections" [value]="sectionName">{{ sectionName }}</option>
						</select>

						<select class="form-control" [(ngModel)]="bulkVisibility">
							<option value="">Keep visibility</option>
							<option *ngFor="let visibility of allowedVisibilityTargets" [value]="visibility">{{ visibility }}</option>
						</select>

						<select class="form-control" [(ngModel)]="bulkScope" (ngModelChange)="onBulkScopeChanged()">
							<option value="">Keep scope</option>
							<option *ngFor="let scope of allowedScopes" [value]="scope">{{ scope }}</option>
						</select>

						<select
							class="form-control form-control--multi"
							multiple
							size="5"
							(change)="setBulkTargetApplicationKeys($event)"
						>
							<option *ngFor="let application of availableApplications" [value]="application.applicationKey" [selected]="isBulkTargetApplicationSelected(application.applicationKey)">
								{{ application.displayName }}
							</option>
						</select>

						<dx-button
							text="Apply Bulk Update"
							type="default"
							[disabled]="!canApplyBulkUpdate"
							(onClick)="applyBulkUpdate()"
						></dx-button>
					</div>
				</div>

				<div class="callout callout--info" *ngIf="isDirty">
					Save the draft before using the bulk-update endpoint or refreshing the backend preview.
				</div>

				<section class="draft-sections">
					<div class="section-header">
						<h5 class="section-title">Grouped draft sections</h5>
						<dx-button text="Add Section" type="default" (onClick)="addSection()"></dx-button>
					</div>

					<div class="draft-section card" *ngFor="let section of editorPayload.sections; let sectionIndex = index; trackBy: trackBySectionIndex">
						<div class="draft-section__header">
							<select class="form-control" [(ngModel)]="section.sectionName" (ngModelChange)="markDirty()">
								<option *ngFor="let sectionName of allowedSections" [value]="sectionName">{{ sectionName }}</option>
							</select>

							<div class="action-row action-row--tight">
								<dx-button text="Add Item" type="default" (onClick)="addItem(section)"></dx-button>
								<dx-button text="Remove Section" type="danger" (onClick)="removeSection(sectionIndex)"></dx-button>
							</div>
						</div>

						<div class="draft-item" *ngFor="let item of section.items; let itemIndex = index; trackBy: trackByItemId">
							<div class="draft-item__select">
								<input
									type="checkbox"
									[checked]="isBulkSelected(item.id)"
									(change)="toggleBulkSelection(item.id, $any($event.target).checked)"
								/>
							</div>

							<div class="draft-item__body">
								<div class="draft-item__meta">
									<select class="form-control form-control--small" [(ngModel)]="item.visibility" (ngModelChange)="markDirty()">
										<option *ngFor="let visibility of allowedVisibilityTargets" [value]="visibility">{{ visibility }}</option>
									</select>

									<select class="form-control form-control--small" [(ngModel)]="item.scope" (ngModelChange)="onItemScopeChanged(item)">
										<option *ngFor="let scope of allowedScopes" [value]="scope">{{ scope }}</option>
									</select>

									<span class="badge badge-light" *ngIf="item.isManuallyEdited">Manual</span>
									<span class="badge badge-light" *ngIf="!item.isManuallyEdited">Generated</span>
								</div>

								<textarea
									class="form-control textarea"
									rows="3"
									[(ngModel)]="item.text"
									(ngModelChange)="markDirty()"
									placeholder="User-facing changelog text"
								></textarea>

								<div class="target-apps" *ngIf="item.scope === 'Application'">
									<label class="field field--wide">
										<span>Target applications</span>
										<select class="form-control form-control--multi" multiple size="5" (change)="setItemTargetApplicationKeys(item, $event)">
											<option *ngFor="let application of availableApplications" [value]="application.applicationKey" [selected]="isItemTargetApplicationSelected(item, application.applicationKey)">
												{{ application.displayName }}
											</option>
										</select>
									</label>
								</div>

								<div class="source-reference-list" *ngIf="item.sourceReferences.length > 0">
									<span class="source-reference" *ngFor="let source of item.sourceReferences">
										{{ source.sourceApplicationKey }} #{{ source.rawSortOrder }} {{ source.rawSectionName }}<span *ngIf="source.sourceFile"> · {{ source.sourceFile }}</span>
									</span>
								</div>
							</div>

							<div class="draft-item__actions">
								<dx-button text="Remove" type="danger" (onClick)="removeItem(section, itemIndex)"></dx-button>
							</div>
						</div>
					</div>
				</section>
			</div>
		</section>

		<section class="workspace__column card" *ngIf="hasSelection">
			<div class="card-body" *ngIf="release != null">
				<div class="section-header section-header--stack">
					<div>
						<h5 class="section-title">Preview and grouped sources</h5>
						<div class="section-meta">
							<span *ngIf="release.publishedAtUtc">Published {{ release.publishedAtUtc | date:'yyyy-MM-dd HH:mm' }}</span>
							<span *ngIf="release.updatedAtUtc">Updated {{ release.updatedAtUtc | date:'yyyy-MM-dd HH:mm' }}</span>
						</div>
					</div>

					<div class="preview-controls">
						<select class="form-control" [(ngModel)]="previewAudience">
							<option *ngFor="let audience of allowedPreviewAudiences" [value]="audience">{{ audience }}</option>
						</select>

						<select class="form-control" [(ngModel)]="previewStage">
							<option value="Draft">Draft</option>
							<option value="Published">Published</option>
						</select>

						<select class="form-control form-control--multi" multiple size="5" (change)="setPreviewApplicationKeys($event)">
							<option *ngFor="let application of availableApplications" [value]="application.applicationKey" [selected]="isPreviewApplicationSelected(application.applicationKey)">
								{{ application.displayName }}
							</option>
						</select>

						<dx-button text="Refresh Preview" type="default" [disabled]="loadingPreview || isDirty" (onClick)="refreshPreview()"></dx-button>
					</div>
				</div>

				<div class="preview-panel" *ngIf="preview != null; else previewPlaceholder">
					<h4>{{ preview.payload.title }}</h4>
					<p class="muted">{{ preview.payload.releaseFamilyName }} {{ preview.payload.version }}<span *ngIf="preview.payload.releaseDate"> · {{ preview.payload.releaseDate }}</span></p>
					<p *ngIf="preview.payload.summary">{{ preview.payload.summary }}</p>

					<div class="callout callout--warning" *ngFor="let warning of preview.validationWarnings">
						<strong>{{ warning.code }}</strong>: {{ warning.message }}
					</div>

					<div class="preview-section" *ngFor="let section of preview.payload.sections">
						<h6>{{ section.sectionName }}</h6>
						<ul>
							<li *ngFor="let item of section.items">
								<span>{{ item.text }}</span>
								<span class="inline-meta">{{ item.scope }}</span>
								<span class="inline-meta" *ngIf="item.targetApplicationKeys.length > 0">{{ item.targetApplicationKeys.join(', ') }}</span>
							</li>
						</ul>
					</div>
				</div>

				<ng-template #previewPlaceholder>
					<div class="callout callout--info">Load or refresh a saved draft to see the backend preview.</div>
				</ng-template>

				<details class="details-block" open>
					<summary>Saved grouped sources</summary>
					<div class="source-summary-list">
						<button
							type="button"
							class="source-summary"
							*ngFor="let source of release.sources; trackBy: trackBySourceId"
							[class.source-summary--active]="selectedSourceId === source.id"
							(click)="inspectSource(source.id)"
						>
							<div class="source-summary__header">
								<strong>{{ source.applicationName || source.applicationKey }}</strong>
								<span class="muted">{{ source.version }}</span>
							</div>
							<div class="source-summary__meta">
								<span>{{ source.itemCount }} items</span>
								<span *ngIf="source.buildVersion">{{ source.buildVersion }}</span>
								<span *ngIf="source.sourceBranch">{{ source.sourceBranch }}</span>
							</div>
							<div class="source-summary__sections">{{ formatSectionOverview(source.sections) }}</div>
						</button>
					</div>
				</details>

				<details class="details-block" [open]="selectedSourceDetail != null">
					<summary>Selected raw source</summary>
					<div *ngIf="loadingSourceDetail" class="callout callout--info">Loading raw source detail...</div>
					<div *ngIf="!loadingSourceDetail && selectedSourceDetail != null">
						<div class="section-header section-header--stack source-detail__header">
							<div>
								<h6 class="section-title">{{ selectedSourceDetail.applicationName || selectedSourceDetail.applicationKey }} {{ selectedSourceDetail.version }}</h6>
								<div class="section-meta">
									<span *ngIf="selectedSourceDetail.buildVersion">{{ selectedSourceDetail.buildVersion }}</span>
									<span *ngIf="selectedSourceDetail.sourceBranch">{{ selectedSourceDetail.sourceBranch }}</span>
								</div>
							</div>
						</div>

						<div class="raw-section" *ngFor="let section of selectedSourceDetail.sections">
							<h6>{{ section.sectionName }} <span class="muted">({{ section.itemCount }})</span></h6>
							<ul>
								<li *ngFor="let item of section.items">
									{{ item.description }}
									<span class="muted" *ngIf="item.sourceFile"> · {{ item.sourceFile }}</span>
								</li>
							</ul>
						</div>

						<details class="details-block details-block--nested" *ngIf="selectedSourceDetail.fragments.length > 0">
							<summary>Fragment markdown</summary>
							<div class="fragment" *ngFor="let fragment of selectedSourceDetail.fragments">
								<h6>{{ fragment.relativePath || fragment.fileName }}</h6>
								<pre>{{ fragment.markdown }}</pre>
							</div>
						</details>

						<details class="details-block details-block--nested">
							<summary>Raw payload JSON</summary>
							<pre>{{ selectedSourceDetail.rawPayloadJson }}</pre>
						</details>
					</div>
					<div *ngIf="!loadingSourceDetail && selectedSourceDetail == null" class="callout callout--info">
						Select a grouped source above to inspect the original export.
					</div>
				</details>
			</div>
		</section>
	</div>
</section>

<ng-template #emptyState>
	<section class="workspace__column workspace__column--editor card">
		<div class="card-body">
			<div class="callout callout--info">Select a grouped release from the left grid to edit merged release notes and per-application targeting.</div>
		</div>
	</section>
</ng-template>







